import { createSelector } from "reselect";
import { RootState } from "store";

const selectServerTime = (state: RootState) => state.serverTime;

const makeSelectDeviation = () =>
  createSelector(
    selectServerTime,
    (serverTimeState) => serverTimeState.deviation,
  );

export { selectServerTime, makeSelectDeviation };
